<template>
  <div id="app">
    <PageScope></PageScope>
  </div>
</template>

<script>
  import PageScope from './components/PageScope.vue'
  export default {
    name: 'app',

    components: {
      PageScope
    }
  }
</script>

<style>
  body{
    background: #e2e2e2 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue